/* eslint-disable import/no-unresolved */
import React, { useContext, useEffect } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { useMutation, useQuery } from 'react-query';
import { useHistory } from 'react-router-dom';
import { loyaltyScreens, currencies } from '../../../../utilities/constants';
import MainBodyLayout from '../partials/MainBodyLayout';
import { LoyaltyContext } from '../../../../contexts/loyalty/context';
import { dynamicAssets } from '../../../../utilities/helpers';
import BasicContainer from '../../../../components/BasicContainer';
import CurrencyIcon from '../../../../components/CurrencyIcon';
import { CARD_SEND_CASHBACK_REWARD } from '../../mutations';
import { showAlert } from '../../../../utilities/notifications';
import { formatNumber } from '../../../../utilities/formatHelpers';
import { CARD_LOAD_CASHBACK } from '../../queries';
import { useRate } from '../../../../utilities/sharedHooks/rates';
import { USER_PREFERENCES } from '../../../../utilities/sharedQueries';
import { useUsEnv } from '../../../../utilities/sharedHooks/useUsEnv';

const ClaimReward = () => {
  const { t: translate } = useTranslation();
  const { state, openScreen } = useContext(LoyaltyContext);
  const history = useHistory();

  const { isUsEnv } = useUsEnv();

  const { data: userPref } = useQuery(USER_PREFERENCES);
  const userDisplayCurrency = userPref?.displayCurrency || 'EUR';

  const { refetch: refetchCashbackData, data: cashbackData } = useQuery(CARD_LOAD_CASHBACK);

  const selectedCurrency = state?.screenOptions?.coin;
  const coin = selectedCurrency?.currency_display_name || cashbackData?.cashback_currency;
  const pct = selectedCurrency?.cashback_reward_percent || cashbackData?.cashback_pct;

  const conversionRate = useRate(cashbackData?.cashback_currency, userDisplayCurrency, true);
  const currency = currencies[cashbackData?.cashback_currency?.toUpperCase()];
  const caschbackDisplayCurrencyAmount =
    cashbackData?.total_reward_amount * conversionRate * currency.conversion;

  const cashbackCurrencyConvertedAmount = `≈${formatNumber(
    caschbackDisplayCurrencyAmount,
    currencies[userDisplayCurrency].decimal
  )} ${userDisplayCurrency}`;

  const availableCashbackRaward = formatNumber(
    cashbackData?.total_reward_amount * currency.conversion,
    currency?.decimal
  );

  const { mutate: sendCashbackReward, isLoading } = useMutation(CARD_SEND_CASHBACK_REWARD, {
    onSettled: (data, error) => {
      if (error) {
        showAlert({ message: error.message, type: 'danger' });
      } else {
        showAlert({
          message: translate(
            isUsEnv
              ? 'loyalty_program_cashback_claim_reward_us_success'
              : 'loyalty_program_cashback_claim_reward_success'
          ),
          type: 'success',
        });
        history.push('/dashboard/card/details');
      }
    },
  });

  useEffect(() => {
    window.scrollTo(0, 0);
    refetchCashbackData();
  }, [refetchCashbackData, selectedCurrency]);

  const handleOnClick = () => {
    sendCashbackReward();
  };

  const closeBanner = () => history.push('/dashboard/card/details');
  return (
    <MainBodyLayout className="loyalty-claim-reward-banner-container">
      <div className="w-100 d-flex select-cashback-title mb-3">
        <div
          className="d-none d-md-flex modal-title cursor-pointer text-hover  select-cashback-title-arrow"
          onClick={closeBanner}
          onKeyDown={closeBanner}
          role="presentation">
          <i className="icon icon-arrow-back-navigation text-f4 me-2" aria-label="Back" />
        </div>
        {/* mobile */}
        <p className="d-block d-md-none select-cashback-title-text text-bold text-f5">
          {translate('loyalty_program_label')}
        </p>

        {/* browser */}
        <p className="d-none d-md-block select-cashback-title-text text-bold text-f4">
          {translate('loyalty_program_label')}
        </p>
      </div>
      <div className="position-relative loyalty-claim-reward-banner  w-100 rounded-extra p-2 ps-3 p-md-4">
        <img
          className="payment-banner-image rounded-extra"
          src={dynamicAssets('./assets/images/loyalty-banner.png')}
          width="100%"
          height="100%"
          alt="plus"
        />
      </div>
      <div className="d-flex flex-column mt-4 pt-3 ">
        <div />
        <p className="text-f5 text-bold">
          {translate(isUsEnv ? 'loyalty_program_us_title' : 'loyalty_program_title')}
        </p>

        <p className="text-f6 text-shadow mt-3">
          {translate(isUsEnv ? 'loyalty_program_us_body' : 'loyalty_program_body')
            .replace('__AMOUNT__', availableCashbackRaward)
            .replace('__COIN__', coin)
            .replace('__CURRENCY__', coin)}
        </p>

        <p className="text-f6 text-shadow mt-3">
          {translate(isUsEnv ? 'loyalty_program_us_subtitle' : 'loyalty_program_subtitle')}
        </p>
      </div>
      <p className="text-f5 claim-reward-title text-bold mt-5 mb-3 ms-3">
        {translate(
          isUsEnv ? 'loyalty_program_cashback_us_amount' : 'loyalty_program_cashback_amount'
        )}
      </p>
      <div className="claim-reward-contaniner d-flex p-2 rounded justify-content-between">
        <div>
          <p className="text-f5 text-bold mt-2 ms-3">
            <Trans
              i18nKey="loyalty_program_available_cashback_currency_sublabel"
              values={{
                amount: availableCashbackRaward,
                currency: coin,
              }}
              components={[<span key="amount" className="text-white" />]}
            />
          </p>
          <p className="text-f6 text-bold text-shadow mt-1 ms-3">
            {cashbackCurrencyConvertedAmount}
          </p>
        </div>
        <button
          onClick={handleOnClick}
          className="btn btn-primary my-2 text-f6 w-10 flex-wrap justify-content-center align-content-center d-flex"
          disabled={availableCashbackRaward <= 0 || isLoading}
          style={{ maxHeight: '35px' }}
          type="button">
          {translate('loyalty_program_claim_rewards')}
        </button>
      </div>

      <p className="text-f5 claim-reward-title text-bold mt-5 mb-3 ms-3">
        {translate(
          isUsEnv ? 'loyalty_program_cashback_us_currency' : 'loyalty_program_cashback_currency'
        )}
      </p>
      <BasicContainer
        className="py-3  cursor-pointer hover-container select-cashback-contaniner px-4"
        onClick={() =>
          openScreen(loyaltyScreens.SELECT_CASHBACK, {
            prevScreen: loyaltyScreens.CLAIM_REWARD,
          })
        }>
        <div className="d-flex flex-row align-items-center justify-content-between">
          <CurrencyIcon
            currencyCode={coin}
            style={{
              height: '2rem',
              width: '2rem',
            }}
            className="m-0 d-flex"
          />

          <div className="col-9 ms-2 ms-4">
            <p>
              <b>{coin}</b>
            </p>
            <p className="text-shadow text-f6">
              {translate(
                isUsEnv
                  ? 'loyalty_program_cashback_currency_us_percent'
                  : 'loyalty_program_cashback_currency_percent'
              ).replace('__PERCENT__', pct)}
            </p>
          </div>
          <i
            style={{ width: '1rem' }}
            className="icon icon-arrow-next-navigation text-primary text-f4 cursor-pointer"
            role="button"
            aria-label={translate('manage_your_accounts_label')}
            tabIndex={0}
            onKeyDown={() => {}}
            onClick={() => {}}
          />
        </div>
      </BasicContainer>
    </MainBodyLayout>
  );
};

export default ClaimReward;
